/**
 * 新規お試しモニター専用LPへの導線ブロック（料金表の独立CTA）。
 *
 * 【SBDCの価格掲載ルール】
 *   公式サイト ＝ 定価のみを掲載する。
 *   LPサイト   ＝ 新規お試しモニター価格を掲載する。
 * したがって、このブロックにはモニター価格・割引率・通常価格との比較・キャンペーン価格などの
 * 価格訴求を一切掲載しない。あくまで「定価料金表を確認した後の案内」として、LPへの出口のみを設置する。
 * 広告的表現（SALE / CAMPAIGN / 限定価格 / ○円OFF 等）は使用しない。
 *
 * 外部LPへの遷移は別タブ（target="_blank" rel="noopener noreferrer"）で行い、
 * 既存の医療脱毛・Medical Slim ZEROページのLP導線と挙動を統一する。
 */
type MonitorLpBlockProps = {
  /** 小見出し（初めての方へ 等） */
  eyebrow: string;
  /** ブロック見出し */
  title: string;
  /** 説明文 */
  description: string;
  /** ボタンラベル */
  label: string;
  /** 遷移先（外部LP） */
  url: string;
};

export default function MonitorLpBlock({
  eyebrow,
  title,
  description,
  label,
  url,
}: MonitorLpBlockProps) {
  return (
    <div className="flex flex-col gap-7 border border-accent-300 bg-accent-50/70 p-8 md:flex-row md:items-center md:justify-between md:p-10">
      <div>
        <span className="text-[11px] font-medium tracking-[0.18em] text-accent-700 md:text-[12px]">
          {eyebrow}
        </span>
        <p className="mt-4 max-w-2xl font-heading text-[16px] leading-[1.9] text-foreground-900 md:text-lg">
          {title}
        </p>
        <p className="mt-3 max-w-2xl text-[12.5px] leading-[2] text-foreground-600">{description}</p>
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex w-full max-w-full items-center justify-center gap-2 rounded-md bg-primary-600 px-5 py-3.5 text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-700 sm:gap-3 sm:px-8 sm:text-[14px] md:inline-flex md:w-auto md:shrink-0 md:whitespace-nowrap"
      >
        <span className="min-w-0 leading-snug">{label}</span>
        <i
          className="ri-arrow-right-line shrink-0 transition-transform group-hover:translate-x-1"
          aria-hidden
        />
      </a>
    </div>
  );
}